import { graphql } from 'react-apollo'
import { Layout, Table, Button } from 'antd'
import moment from 'moment-timezone'
import PropTypes from 'prop-types'
import React from 'react'
import XLSX from 'xlsx'

import sellsQuery from '../graphql/queries/sells'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'

const { Content } = Layout

const SellItems = (props) => {
  const { sells: { loading, sells = [] } } = props
  const exportExcel = () => {
    const excelData = []
    sells.forEach((sell) => {
      sell.items.forEach((item) => {
        excelData.push({
          'Sell ID': sell._id,
          Total: sell.total,
          Name: (item.product ? `${item.product.name} ${item.product.size} ${item.product.color}` : 'DELETED PRODUCT'),
          Price: item.product.price,
          'Sell By': sell.sellBy.name,
          Date: moment(sell.sellAt).tz('Asia/Bangkok').format('YYYY-MM-DD'),
          Time: moment(sell.sellAt).tz('Asia/Bangkok').format('HH:mm:SS'),
        })
      })
    })
    const workbook = XLSX.utils.book_new()
    const worksheet = XLSX.utils.json_to_sheet(excelData)
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1')
    XLSX.writeFile(workbook, `sells-${moment().format('YYYYMMDDHHmmSS')}.xlsx`)
  }
  const columns = [
    {
      title: 'ID',
      dataIndex: '_id',
      key: 'id',
      width: 240,
    },
    {
      title: 'Total',
      dataIndex: 'total',
      key: 'total',
    },
    {
      title: 'Items',
      key: 'items',
      render: record => (
        <ul style={{ paddingLeft: '20px' }}>
          {record.items && record.items.map(item => (
            <li key={item.itemId}>{item.product ? `${item.product.name} ${item.product.size} ${item.product.color}` : 'DELETED PRODUCT'}</li>
          ))}
        </ul>
      ),
    },
    {
      title: 'Sell by',
      dataIndex: 'sellBy.name',
      key: 'sellBy.name',
    },
    {
      title: 'Timestamp',
      key: 'sellAt',
      width: 200,
      render: record => moment(record.sellAt).tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:SS'),
    },
  ]
  return (
    <Layout>
      <Navbar selected="sell:1" />
      <Content style={{ padding: '0 20px' }}>
        <div style={{ background: '#fff', padding: 24, minHeight: 'calc(100vh - 64px - 69px)' }}>
          <h2>
            Sell items
            <Button
              type="primary"
              onClick={exportExcel}
              style={{ float: 'right', marginRight: '10px' }}
            >
              Export excel
            </Button>
          </h2>
          <Table
            dataSource={sells}
            columns={columns}
            rowKey="_id"
            pagination={{ pageSize: 50 }}
            size="middle"
            loading={loading}
            bordered
          />
        </div>
      </Content>
      <Footer />
    </Layout>
  )
}
SellItems.propTypes = {
  sells: PropTypes.shape({
    error: PropTypes.object,
    loading: PropTypes.bool,
    sells: PropTypes.array,
  }).isRequired,
}
SellItems.defaultProps = {}

export default graphql(sellsQuery, { name: 'sells' })(SellItems)



// WEBPACK FOOTER //
// ./src/pages/SellItems.js